import { render, staticRenderFns } from "./goods-manage.vue?vue&type=template&id=2675169c&scoped=true"
import script from "./goods-manage.vue?vue&type=script&lang=js"
export * from "./goods-manage.vue?vue&type=script&lang=js"
import style0 from "./goods-manage.vue?vue&type=style&index=0&id=2675169c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2675169c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2675169c')) {
      api.createRecord('2675169c', component.options)
    } else {
      api.reload('2675169c', component.options)
    }
    module.hot.accept("./goods-manage.vue?vue&type=template&id=2675169c&scoped=true", function () {
      api.rerender('2675169c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/components/goods-manage.vue"
export default component.exports